import type { Dispatch } from 'redux';
import Directory from '@atlassian/jira-directory-base/src/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { ITEMS_PER_PAGE, type Query } from '../model/index.tsx';
import { ready } from '../state/actions/app/index.tsx';
import {
	patch as patchComponent,
	retrieve as retrieveComponents,
} from '../state/actions/dashboards/index.tsx';
import { patchQuery } from '../state/actions/query/index.tsx';
import { getIds, getTotal, isLoading, isError } from '../state/selectors/dashboards/index.tsx';
import {
	getSortField,
	getSortDirection,
	getPage,
	getFilter,
	isFilterApplied,
} from '../state/selectors/query/index.tsx';
import type { State, Action } from '../state/types.tsx';
import EmptyView from './content/empty/index.tsx';
import ErrorView from './content/error/index.tsx';
import FilterView from './content/filter/index.tsx';
import {
	operationModals,
	emptyFilterResultConfiguration,
	getTableConfiguration,
	getTableLabel,
	getResultsAnnouncerMessage,
} from './selectors.tsx';

const mapStateToProps = (state: State) => ({
	// data
	entityIds: getIds(state),
	totalItems: getTotal(state),
	itemsPerPage: ITEMS_PER_PAGE,
	isLoading: isLoading(state),
	isError: isError(state),
	page: getPage(state),
	sortField: getSortField(state),
	sortDirection: getSortDirection(state),
	filter: isFilterApplied(state) ? getFilter(state) : undefined,

	// ui
	firstColumnHeadingAlignment: 'center',
	lastColumnHeadingAlignment: 'right',

	// views
	FilterView,
	tableConfiguration: getTableConfiguration(state),
	tableLabel: getTableLabel(),
	resultsAnnouncerMessage: getResultsAnnouncerMessage(),
	emptyFilterResultConfiguration,
	operationModals,
	EmptyView,
	ErrorView,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
	// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'patch' implicitly has an 'any' type.
	onPatch: ({ id, patch }) => dispatch(patchComponent({ id, patch })),
	onReload: (query: Partial<Query>) => {
		dispatch(patchQuery(query));
		dispatch(retrieveComponents());
	},
	onFirstRender: () => dispatch(ready()),
});

// @ts-expect-error - TS2345 - Argument of type 'typeof Directory' is not assignable to parameter of type 'Component<{ entityIds: string[]; totalItems: number; itemsPerPage: number; isLoading: boolean; isError: boolean; page: number; sortField: SortField; sortDirection: SortDirection; ... 8 more ...; ErrorView: ComponentClass<...> & { ...; }; } & { ...; }>'.
export default connect(mapStateToProps, mapDispatchToProps)(Directory);
